import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';

import { AuthService } from '../app/core/auth/auth.service';
import { PaymentService } from '../app/core/auth/payment.service';

@Injectable({ providedIn: 'root' })
export class AuthGuard  {

  constructor(
    private authService: AuthService,
    private paymentService: PaymentService,
    private router: Router
  ) {
  }

  /**
   * If returns true the navigation process continues
   * If the user is not authenticated, the user is redirected to login.
   *
   * @param next
   * @param state
   * @returns
   */
  async canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Promise<boolean> {
    // If user is not logged in, redirect to login
    console.log(next, state);
    const urlWithoutParams = state.url.split('?')[0];
    if (!this.authService.isAuthenticated()) {
      localStorage.setItem('redirectUrl', urlWithoutParams);
      this.router.navigate(['signup']);
      return false;
    }

    if (!this.authService.currentStudent && !this.authService.currentStudent.demographicsComplete) {
      this.router.navigate(['signup']);
      localStorage.setItem('redirectUrl', urlWithoutParams);
      return false;
    }
    if (!this.authService.currentStudent.stripeId && !(await this.paymentService.checkSubscriptionStatus()).authorized) {
      await this.paymentService.checkSubscriptionStatus();
      this.paymentService.$openPaymentFreezeModalHandler.next(null);
    }

    if (!localStorage.getItem('selectedCountry') || !localStorage.getItem('selectedCourse')) {
      this.router.navigate(['signup/location-and-game']);
      localStorage.setItem('redirectUrl', urlWithoutParams);
      return false;
    }

    return true;
  }
}
